export class GlobalListeners {
  constructor() {
    this.selectors = {
      quickAdds: '[quick-add-qf]',
      productForm: `[action="${window.Shopify.routes.root}cart/add"]`,
      openSideCart: '.openSideCart',
      closeSideCart: '.closeSideCart',
      removeButtons: '.cart .items-wrapper .item .remove-item',
      quantitySelectorPlus: '.cart .items-wrapper .item .quantity-wrapper .plus',
      quantitySelectorMinus: '.cart .items-wrapper .item .quantity-wrapper .minus',
      cartCount: '.cart-count',
      accordion: 'accordion',
      product_description: '[read-more-container]',
      quickview: '[open-quick-view]',
      quickviewModal: '.quick-view-container',
      quickviewClose: '.quick-view-container .close',
      quantitySelect: '[quantity-select]',
      quantityPlus: '[quantity-plus]',
      quantityMinus: '[quantity-minus]',
      quantity: '[quantity]',
      quickAddTrigger: '[quick-add-trigger]',
      quickAddClose: '[close-quick-add-trigger]',
      quickAddPopup: '[quick-add-popup]',
      quickAddMobileContainer: '[quick-add-mobile-container]',
      productCard: '[product-card]',
      productCardSwatch: '[card-swatch]',
      quickAddProductSwatch: '[product-card-swatch]',
      mergedProductImage: '[merged_product-img]',
      annoucementBar: '.announcement-bar',
      transparentmegaMenu: '.mega-menu.transparent',
      header: '.mega-menu-outer-shopify-wrapper',
      main_content: '#MainContent',
    };

    this.init();
  }

  init() {
    document.body.addEventListener('click', this.handleEvent.bind(this));
    document.body.addEventListener('submit', this.handleFormSubmit.bind(this));
    this.cartRelated();
    this.hideAnnouncementBar();
  }

  handleFormSubmit(e) {
    this.productForm(e);
  }

  handleEvent(e) {
    // this.headerSearch(e);
    this.siteCart(e);
    this.quantityButtons(e);
    this.removeCartItem(e);
    this.accordions(e);
    this.sideCartTabs(e);
    // this.mobileMenu(e);
    this.openQuickView(e);
    this.closeQuickView(e);
    this.openCartBundles(e);
    this.quantityPlus(e);
    this.quantityMinus(e);
    this.quickAdd(e);
    this.closeQuickAddPopup(e);
    this.productCardSwatches(e);
    this.quickAddProductSwatches(e);
  }

  // intersection observer when announcement bar is not in viewport add class "hidden"

  hideAnnouncementBar() {
    const announcementBar = document.querySelector(this.selectors.annoucementBar);
    const transparentmegaMenu = document.querySelector(this.selectors.transparentmegaMenu);
    const header = document.querySelector(this.selectors.header);
    const main_content = document.querySelector(this.selectors.main_content);
    if (announcementBar && header) {
      if (!transparentmegaMenu) {
        announcementBar.classList.remove('transparent');
        announcementBar.querySelectorAll('a,.swiper-slide').forEach(link => {
          link.style.color = 'black';

        });
      } else {
        announcementBar.classList.add('transparent');
        announcementBar.querySelectorAll('a,.swiper-slide').forEach(link => {
          link.style.color = 'white';
        });
      }
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            announcementBar.classList.add('hidden');
            header.classList.add('scrolled');
            if (!transparentmegaMenu) {
              // main_content.classList.remove('header-sticky');
            }
          } else {
            announcementBar.classList.remove('hidden');
            header.classList.remove('scrolled');
            if (!transparentmegaMenu) {
              // main_content.classList.add('header-sticky');
            }
          }
        });
      });

      observer.observe(announcementBar);
    }
  }

  productCardSwatches(e) {
    const swatch = e.target.closest(this.selectors.productCardSwatch);
    if (swatch) {
      const handle = swatch.getAttribute('data-handle');
      const id = swatch.getAttribute('data-id');
      const url = swatch.getAttribute('data-url');
      const productCard = swatch.closest(this.selectors.productCard);
      const swatches = productCard.querySelectorAll(this.selectors.productCardSwatch);

      swatches.forEach(swatch => {
        swatch.classList.remove('selected');
      });
      swatch.classList.add('selected');

      const quickAddPopup = productCard.querySelector(this.selectors.quickAddPopup);

      if (quickAddPopup) {
        const img = quickAddPopup.closest(this.selectors.productCard).querySelector(".product-image");
        if (img) {
          img.style.pointerEvents = "auto";
        }
        setTimeout(() => {
          if (window.innerWidth < 768) {
            quickAddPopup.classList.remove("mobile");
          }
        }, 300);
        quickAddPopup.classList.remove("active");
      }


      // Change links
      const links = productCard.querySelectorAll("a");
      links.forEach(link => {
        link.setAttribute('href', url);
      });

      // hide all images
      const merged_images = productCard.querySelectorAll(this.selectors.mergedProductImage);
      merged_images.forEach(img => {
        img.innerHTML = '';
        img.style.display = 'none';
      });
      // find image
      const merged_img = productCard.querySelector(`${this.selectors.mergedProductImage}[data-id="${id}"]`);
      if (merged_img) {
        const main_img = productCard.querySelector('.product-image img');
        if (main_img) {
          main_img.style.display = 'none';
        }

        const quickAddTrigger = productCard.querySelector(this.selectors.quickAddTrigger);
        if (quickAddTrigger) {
          quickAddTrigger.setAttribute('data-product-handle', handle);
          quickAddTrigger.setAttribute('data-id', id);
        }

        const mobile_quick_add = productCard.querySelector('.quick-add-trigger.mobile');
        if (mobile_quick_add) {
          mobile_quick_add.setAttribute('data-product-handle', handle);
          mobile_quick_add.setAttribute('data-id', id);
        }

        merged_img.style.display = 'block';
        const imgSrc = merged_img.getAttribute('data-img-src');
        const img = document.createElement('img');
        img.src = imgSrc;
        const has_image = merged_img.querySelector('img');
        if (!has_image) {
          merged_img.appendChild(img);
        }
      }
    }
  }

  quickAddProductSwatches(e) {
    const swatch = e.target.closest(this.selectors.quickAddProductSwatch);

    if (swatch) {

      const handle = swatch.getAttribute('data-handle');
      const sectionName = "pg-quick-add-form";
      const formContainer = document.querySelector(this.selectors.quickAddMobileContainer);
      const form = formContainer.querySelector('.product-form');
      const formHeight = form.offsetHeight;
      const loading_spinner = formContainer.querySelector('.load-more-spinner');
      if (loading_spinner) {
        loading_spinner.style.display = 'block';
      }
      form.style.height = formHeight + "px";

      this.getQuickAddMobileForm(handle, sectionName);
    }
  }


  openCartBundles(e) {
    const target = e.target;
    const recommendationsEl = target.closest('.cart-recommendations');
    if ( target.closest('.toggle-bundles-slider') && recommendationsEl ) {
      recommendationsEl.classList.toggle('open-bundles');
    }
  }

  productForm(e) {
    const productForm = e.target.closest(this.selectors.productForm);
    if (productForm) {
      e.preventDefault();
      const product_id = productForm.getAttribute("id").split("_").pop();
      const quantity_el = productForm.querySelector("[quantity-select] input[type='number']");
      let quantity = 1;
      if (quantity_el) {
        quantity = parseInt(quantity_el.value);
      }
      const section_id = productForm.getAttribute("data-section-id");
      const id = productForm.querySelector("#product-id-" + section_id + "-" + product_id).value;
      console.log("🚀 ~ GlobalListeners ~ productForm ~ id:", id)

      let properties = {};
      const propertyFields = productForm.querySelectorAll('.property');

      if (propertyFields) {
        propertyFields.forEach(field => {
          const key = field.getAttribute('name');
          let value = field.value;
          
          // Translate checkbox value into true/false
          if ( field.type == 'checkbox' ) value = field.checked;
          
          if (key && value) {
            properties[key] = value;
          }
        });
      }

      if (quantity && id) {
        window.cart.add({ items: [{ "id": id, "quantity": quantity, "properties": properties }] });
        window.wishlist.buttonCheck();
      }
    }
  }

  siteCart(e) {
    // SITE CART OPEN AND CLOSE
    if (!window.QF.settings.sideCart) return;

    const openSideCart = e.target.closest(this.selectors.openSideCart);
    if (openSideCart) {
      e.preventDefault();
      window.cart.openSideCart();
    }

    const closeSideCart = e.target.closest(this.selectors.closeSideCart);
    if (closeSideCart) {
      e.preventDefault();
      window.cart.closeSideCart();
    }

    if (e.target.classList.contains('cart-drawer-container')){
      window.cart.closeSideCart();
    }
  }

  quantityButtons(e) {
    // QUANTITY PLUS CART
    const quantityPlus = e.target.closest(this.selectors.quantitySelectorPlus);
    if (quantityPlus) {
      if (quantityPlus.getAttribute("data-pending") === "true") return;
      quantityPlus.setAttribute("data-pending", true);

      const quantityElement = quantityPlus.parentNode.querySelector(".quantity span");
      const stock = quantityElement.getAttribute("data-stock");
      const current = parseInt(quantityElement.innerHTML);
      const variant_key = quantityElement.closest('.item').getAttribute("data-variant-key");
      const inv_policy = quantityElement.getAttribute("data-inventory-policy");
      if (inv_policy === "continue" || stock > 0) {
        // if in stock or continue selling when out of stock, update cart
        const updated = current + 1;
        window.cart.change({ "id": variant_key, "quantity": updated });
      }
    }

    // QUANTITY MINUS CART
    const quantityMinus = e.target.closest(this.selectors.quantitySelectorMinus);
    if (quantityMinus) {
      if (quantityMinus.getAttribute("data-pending") === "true") return;
      quantityMinus.setAttribute("data-pending", true);

      const quantity = quantityMinus.parentNode.querySelector(".quantity span");
      const current = parseInt(quantity.innerHTML);
      const variant_key = quantity.closest('.item').getAttribute("data-variant-key");

      if (current > 0) {
        const updated = current - 1;
        window.cart.change({ "id": variant_key, "quantity": updated });
      }
    }
  }

  quantityPlus(e) {
    const plus = e.target.closest(this.selectors.quantityPlus);

    if (plus) {
      const quantity_input = plus.closest(this.selectors.quantitySelect).querySelector("input[type='number']");
      const quantity = plus.closest(this.selectors.quantitySelect).querySelector(this.selectors.quantity);
      const new_value = parseInt(quantity_input.value) + 1;
      const max = quantity_input.getAttribute("max");

      if (new_value <= max) {
        quantity_input.value = new_value;
        quantity.innerHTML = new_value;
      }

    }
  }

  quantityMinus(e) {
    const minus = e.target.closest(this.selectors.quantityMinus);

    if (minus) {
      const quantity_input = minus.closest(this.selectors.quantitySelect).querySelector("input[type='number']");
      const quantity = minus.closest(this.selectors.quantitySelect).querySelector(this.selectors.quantity);
      const new_value = parseInt(quantity_input.value) - 1;

      if (new_value > 0) {
        quantity_input.value = new_value;
        quantity.innerHTML = new_value;
      }
    }
  }

  removeCartItem(e) {
    // REMOVE ITEM CART
    const removeButtons = e.target.closest(this.selectors.removeButtons);
    if (removeButtons) {
      const variant_key = removeButtons.closest('.item').getAttribute("data-variant-key");
      window.cart.change({ "id": variant_key, "quantity": 0});
    }
  }

  cartRelated() {
    // update side cart/cart after change
    const renderCarts = () => {
      if (window.template === "cart") {
        window.cart.reRenderCart();
      } else {
        if (window.QF.settings.ajax_open_side_cart) {
          window.cart.openSideCart();
        } else if (window.QF.settings.ajax_toast) {
          window.cart.reRenderSideCart();
        }
      }
    };
    window.addEventListener("cart_changed", renderCarts);
    window.addEventListener("item_removed", renderCarts);

    // CART COUNT
    window.addEventListener("cart_changed", e => {
      if (e.detail.cart) {
        const cartCount = document.querySelectorAll(".cart-count");
        cartCount.forEach(count => {
          count.innerHTML = e.detail.cart.item_count;
        });
      }
    });
  }

  headerSearch(e) {
    const searchTrigger = document.querySelector('.mega-menu [data-open-search]');
    const searchInput = document.querySelector('.predictive-search-container .search-bar-qf input');
    const searchModal = document.querySelector('.mega-menu-outer-shopify-wrapper .predictive-search-container');
    const header = document.querySelector('.mega-menu-outer-shopify-wrapper .mega-menu');

    if ( searchTrigger && searchModal ) {
      const target = e.target;

      if ( target === searchTrigger || target == searchInput || target.closest('[data-open-search]') || target.closest('.predictive-search-modal') && !target.closest('.close') ) {
        if (!searchTrigger.classList.contains('active')) {

          // Close Mobile Menu
          const menuTrigger = document.querySelector('#open-mobile-menu');
          if ( menuTrigger.classList.contains('active') ) menuTrigger.click();

          searchModal.classList.add('active');
          searchTrigger.classList.add('active');
          // search.classList.add('active');
          header.classList.add('solid');
          searchInput.focus();

        }
      } else {
        searchTrigger.classList.remove('active');
        // search.classList.remove('active');
        searchModal.classList.remove('active');
        header.classList.remove('solid');

      }

      if (e.key === 'Escape') {
        if (searchTrigger.classList.contains('active')) {
          searchTrigger.classList.remove('active');
          // search.classList.remove('active');
          header.classList.remove('solid');

        }
      }
    }
  }

  mobileMenu(e) {
    const menu = document.querySelector('.mobile-menu-outer-wrapper');
    const menuTrigger = document.querySelector('#open-mobile-menu');

    if (menuTrigger && e.target.closest('#open-mobile-menu')) {
      if (menuTrigger.classList.contains('active')) {
        menu.classList.remove('active');
        menuTrigger.classList.remove('active');
      } else {
        menu.classList.add('active');
        menuTrigger.classList.add('active');
      }
    }

    if (e.target === menu) {
      menu.classList.remove('active');
      menuTrigger.classList.remove('active');
    }
  }

  sideCartTabs(e) {
    if (e.target && e.target.closest) {
      const cartTab = e.target.closest('.cart-tab');

      if (cartTab && !cartTab.classList.contains('active')) {

        const cartTabs = document.querySelectorAll('.cart-tab');

        cartTabs.forEach(tab => {
          tab.classList.remove('active');
        });

        let tabSelected = cartTab;
        tabSelected.classList.add('active');
        let tabData = tabSelected.getAttribute('data-tab');
        let cartContents = document.querySelectorAll('.cart-content');

        cartContents.forEach(cartContent => {
          cartContent.style.display = 'none';
        });

        document.querySelector('.' + tabData).style.display = 'flex';

        if (tabData === 'saved-cart') {
          if (window.wishlist && window.wishlist.needsUpdate) {
            window.wishlist.initSideCartGrid();
            window.wishlist.needsUpdate = false;
          } else {
            window.wishlist.initSideCartGrid();
          }
        }
      }
    }
  }

  accordions(e) {

    if (e.target.classList.contains(this.selectors.accordion) || e.target.closest(`.${this.selectors.accordion}`)) {
      e.preventDefault();

      const accordion = e.target.closest(`.${this.selectors.accordion}`);
      const parent = accordion.parentElement;
      const sibling_accordions = parent.getElementsByClassName(this.selectors.accordion);
      const panel = accordion.nextElementSibling;


      if ( sibling_accordions ) {
        Array.from(sibling_accordions).forEach((acc) => {
          if ( acc != accordion || accordion.classList.contains('active') ) {
            acc.nextElementSibling.style.maxHeight = null;
            acc.classList.remove("active");

          } else {
            accordion.classList.add("active");
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      }

    }
  }

  openQuickView(e) {
    // OPEN QUICK VIEW
    const quickView = e.target.closest(this.selectors.quickview);
    if (quickView) {
      e.preventDefault();
      let pageHasRecomendations = document.querySelector(".product-recommendations") || false;
      let timeout = pageHasRecomendations ? 2000 : 0;

      setTimeout(async () => {
          let quickViewModal = document.querySelector(this.selectors.quickviewModal);

          if (quickViewModal) {
            let quickAddFormContainer = quickViewModal.querySelector(".inner");

            let sectionName = "new-main-product";

            let handle = quickView.getAttribute("data-product-handle");
            if (handle) {
              try {
                const response = await fetch(window.Shopify.routes.root + `products/${handle}?sections=${sectionName}`);
                if (response.ok) {
                  const data = await response.json();
                  let html = data[`${sectionName}`];

                  const scripts_to_run = html.match(/<script qv-run>([\s\S]*?)<\/script>/gm);
                  const scripts = [];
                  scripts_to_run.forEach(script => {
                    script = script.replace("</script>", "").replace("<script qv-run>", "");
                    script = script.replace('document.addEventListener("DOMContentLoaded", () => {', "");

                    let closingBraceLocation = script.lastIndexOf("});");
                    script = script.substring(0, closingBraceLocation);

                    scripts.push(script);
                  });
                  if (quickAddFormContainer && html) {
                    quickAddFormContainer.innerHTML = html;

                    scripts.forEach(script_to_eval => {
                      new Function(script_to_eval)();
                    });

                    let qvLightboxButtons = quickAddFormContainer.querySelectorAll('.lightbox-trigger');
                    qvLightboxButtons.forEach( lightbox => {
                      let lightboxHandle = `${ handle }-qv-lightbox`;
                      lightbox.setAttribute('data-fslightbox', lightboxHandle);
                    });

                    // Refresh FsLightbox
                    refreshFsLightbox();


                    // init sliders
                    let gallery_thumbs_swiper = new window.swiper(".inner .thumb-swiper", {
                      spaceBetween: 15,
                      slidesPerView: 4,
                      freeMode: true,
                      watchSlidesProgress: true,
                      breakpoints: {
                        992: {
                          slidesPerView: 4,
                          direction: "vertical",
                        },
                      },
                    });

                    let gallery_swiper = new window.swiper(".inner .main-swiper", {
                      spaceBetween: 20,
                      navigation: {
                        nextEl: ".inner .swiper-button-next",
                        prevEl: ".inner .swiper-button-prev",
                      },
                      thumbs: {
                        swiper: gallery_thumbs_swiper,
                      },
                      on: {
                        init: function () {
                          let check_width = setInterval(() => {
                            setThumbHeight();
                          }, 200);

                          function setThumbHeight() {
                            let main_swiper_slide = document.querySelector('.inner .main-swiper-slide');
                            let thumb_swiper = document.querySelector('.inner .thumb-swiper');

                            let main_swiper_width = main_swiper_slide.offsetWidth;

                            main_swiper_slide.style.height = main_swiper_width + 'px';

                            if (main_swiper_width > 0) {
                              clearInterval(check_width);

                              thumb_swiper.style.cssText = "position: relative;opacity:1";

                              if (window.innerWidth > 991.98) {
                                thumb_swiper.style.height = main_swiper_width + 'px';
                              }
                            }
                          }

                          document.querySelector('.inner .gallery-container').style.opacity = 1;

                          window.addEventListener('resize', () => {
                            let main_swiper_slide = document.querySelector('.inner .main-swiper');
                            let thumb_swiper = document.querySelector('.inner .thumb-swiper');

                            let main_swiper_width = main_swiper_slide.offsetWidth;

                            main_swiper_slide.style.height = main_swiper_width + 'px';

                            if (window.innerWidth > 991.98) {
                              thumb_swiper.style.height = main_swiper_width + 'px';
                            }
                          });
                        },
                      },
                    });

                    // Show quick view modal
                    quickViewModal.classList.add("active");
                  }
                } else {
                  throw new Error('Error: ' + response.status);
                }
              } catch (error) {
                console.error(error);
              }
            }
        }
      }, timeout);
    }
  }

  closeQuickView(e) {
    // CLOSE QUICK VIEW
    const quickViewClose = e.target.closest(this.selectors.quickviewClose);
    if (quickViewClose) {
      e.preventDefault();
      const quickViewModal = document.querySelector(this.selectors.quickviewModal);
      if (quickViewModal) {
        quickViewModal.classList.remove("active");

        // Refresh FsLightbox
        refreshFsLightbox();
      }
    }
  }

  quickAdd(e) {
    const quickAddTrigger = e.target.closest(this.selectors.quickAddTrigger);
    if (quickAddTrigger) {
      e.preventDefault();
      const default_variant = quickAddTrigger.dataset.defaultVariant;
      if (default_variant) {
        const quantity = parseInt(quickAddTrigger.dataset.quantity);
        if (quickAddTrigger.dataset.id && quantity > 0) {
          window.cart.add({ items: [{ "id": quickAddTrigger.dataset.id, "quantity": quantity }] });

          window.wishlist.buttonCheck();

        }
      } else {
        const sectionName = "pg-quick-add-form";

        const handle = quickAddTrigger.getAttribute("data-product-handle");
        if (window.innerWidth < 768) {
          const mobileQuickAdd = document.querySelector(this.selectors.quickAddMobileContainer);
          if (mobileQuickAdd) {
            mobileQuickAdd.classList.add("active");
          }
          this.getQuickAddMobileForm(handle, sectionName);
        } else {
          console.log("🚀 ~ GlobalListeners ~ quickAdd ~ handle:", handle)
          const quickAddPopups = document.querySelectorAll(this.selectors.quickAddPopup);
          const quickAddPopup = quickAddTrigger.closest(this.selectors.productCard).querySelector(this.selectors.quickAddPopup);
          if (quickAddPopup) {
            quickAddPopup.classList.add("active");
          }
          const quickAddFormContainer = quickAddPopup.querySelector(".product-form");

          this.getQuickAddForm(handle, sectionName, quickAddFormContainer, quickAddPopup);
        }
      }
    }
  }

  getQuickAddMobileForm(handle, sectionName) {
    if (handle && sectionName) {
      const quickAddMobileContainer = document.querySelector(this.selectors.quickAddMobileContainer);
      const productFormContainer = quickAddMobileContainer.querySelector(".product-form");
      console.log("🚀 ~ GlobalListeners ~ getQuickAddForm ~ quickAddMobileContianer:", quickAddMobileContainer)
      productFormContainer.innerHTML = "";
      // Fetch product data
      if (!quickAddMobileContainer.classList.contains("opened")) {
        setTimeout(async () => {
            if (handle) {
              try {
                const response = await fetch(window.Shopify.routes.root + `products/${handle}?sections=${sectionName}`);
                if (response.ok) {
                  const data = await response.json();
                  let html = data[`${sectionName}`];

                  const scripts_to_run = html.match(/<script qv-run>([\s\S]*?)<\/script>/gm);
                  const scripts = [];
                  scripts_to_run.forEach(script => {
                    script = script.replace("</script>", "").replace("<script qv-run>", "");

                    scripts.push(script);
                  });

                  if (quickAddMobileContainer && html) {
                    const productFormContainer = quickAddMobileContainer.querySelector(".product-form");
                    console.log("🚀 ~ GlobalListeners ~ setTimeout ~ productFormContainer:", productFormContainer)
                    productFormContainer.style.height = "auto"; // reset height
                    productFormContainer.innerHTML = html;

                    scripts.forEach(script_to_eval => {
                      new Function(script_to_eval)();
                    });
                    // add 'selected' to current handle swatch
                    const swatches = productFormContainer.querySelectorAll(this.selectors.quickAddProductSwatch);
                    swatches.forEach(swatch => {
                      if (swatch.getAttribute('data-handle') === handle) {
                        swatch.classList.add('selected');
                      }
                    });

                    const loading_spinner = quickAddMobileContainer.querySelector('.load-more-spinner');
                    if (loading_spinner) {
                      loading_spinner.style.display = 'none';
                    }
                  }


                } else {
                  throw new Error('Error: ' + response.status);
                }
              } catch (error) {
                console.error(error);
              }
            }
      }, 0);
      }
    }
  }

  getQuickAddForm(handle, sectionName, quickAddFormContainer, quickAddPopup) {
    if (quickAddPopup) {
      quickAddFormContainer.innerHTML = "";
      // Fetch product data
      if (!quickAddPopup.classList.contains("opened")) {
        setTimeout(async () => {
            if (handle) {
              try {
                const response = await fetch(window.Shopify.routes.root + `products/${handle}?sections=${sectionName}`);
                if (response.ok) {
                  const data = await response.json();
                  let html = data[`${sectionName}`];

                  const scripts_to_run = html.match(/<script qv-run>([\s\S]*?)<\/script>/gm);
                  const scripts = [];
                  scripts_to_run.forEach(script => {
                    script = script.replace("</script>", "").replace("<script qv-run>", "");

                    scripts.push(script);
                  });

                  if (quickAddFormContainer && html) {
                    quickAddFormContainer.innerHTML = html;

                    scripts.forEach(script_to_eval => {
                      new Function(script_to_eval)();
                    });


                    const img = quickAddPopup.closest(this.selectors.productCard).querySelector(".product-image");
                    // if window width is less than 768px add class mobile
                    if (img) {
                      img.style.pointerEvents = "none";
                    }

                    // add 'selected' to current handle swatch
                    const swatches = quickAddPopup.querySelectorAll(this.selectors.quickAddProductSwatch);
                    swatches.forEach(swatch => {
                      if (swatch.getAttribute('data-handle') === handle) {
                        swatch.classList.add('selected');
                      }
                    });
                  }
                  quickAddPopup.classList.add("active");

                } else {
                  throw new Error('Error: ' + response.status);
                }
              } catch (error) {
                console.error(error);
              }
            }
      }, 0);
      }
    }

  }

  closeQuickAddPopup(e) {
    const quickAddClose = e.target.closest(this.selectors.quickAddClose);

    if (quickAddClose) {
      e.preventDefault();
      const mobile_wrapper = quickAddClose.closest(this.selectors.quickAddMobileContainer);
      if (mobile_wrapper) {
        mobile_wrapper.classList.remove("active");
      } else {
        e.preventDefault();
        const quickAddPopup = quickAddClose.closest(this.selectors.quickAddPopup);
        if (quickAddPopup) {
          const img = quickAddPopup.closest(this.selectors.productCard).querySelector(".product-image");
          if (img) {
            img.style.pointerEvents = "auto";
          }
          setTimeout(() => {
            if (window.innerWidth < 768) {
              quickAddPopup.classList.remove("mobile");
            }
          }, 300);
          quickAddPopup.classList.remove("active");
        }
      }
    }
  }

}

// window.GlobalListeners = GlobalListeners;
